module.exports = __webpack_public_path__ + "img/w3_cloud_black.e330c373.png";